<template>
  <div class="userCenter">
    <div class="boxCenter">
      <div class="userBox">
        <LeftSide></LeftSide>
        <div class="userRight">
          <div class="userTitle">订单详情</div>
          <div class="subTitle"><span></span>会员信息</div>
          <div class="userInfoBox" style="padding-top: 5px;padding-left: 70px;">
            <el-form ref="form" label-width="90px">
              <el-form-item label="订单编号">
                {{orderData.orderCode}}
                <!-- <el-input v-model="orderData.orderCode" :disabled="true"></el-input> -->
                
              </el-form-item>
              <el-form-item label="创建时间">
                {{orderData.createDate}}
                <!-- <el-input v-model="orderData.createDate" :disabled="true"></el-input> -->
              </el-form-item>
              <el-form-item label="订单状态">
                <span v-if="orderData.status == 1">未支付</span>
                <span v-if="orderData.status == 2">已支付</span>
                <span v-if="orderData.status == 3">已发货</span>
                <span v-if="orderData.status == 4">已收货</span>
                <!-- <el-input v-if="orderData.status == 1" value="未支付" :disabled="true"></el-input>
                <el-input v-if="orderData.status == 2" value="已支付" :disabled="true"></el-input>
                <el-input v-if="orderData.status == 3" value="已发货" :disabled="true"></el-input>
                <el-input v-if="orderData.status == 4" value="已收货" :disabled="true"></el-input> -->
              </el-form-item>
              <el-form-item label="收货人姓名" v-if="orderData.name">
                {{orderData.name}}
                <!-- <el-input v-model="orderData.name" :disabled="true"></el-input> -->
              </el-form-item>
              <el-form-item label="手机号码" v-if="orderData.phone">
                {{orderData.phone}}
                <!-- <el-input v-model="orderData.phone" :disabled="true"></el-input> -->
              </el-form-item>
              <el-form-item label="地址信息" v-if="orderData.address">
                {{orderData.address}}
                <!-- <el-input v-model="orderData.address" :disabled="true"></el-input> -->
              </el-form-item>
              <el-form-item label="付款时间">
                {{orderData.payTime}}
                <!-- <el-input v-model="orderData.payTime" :disabled="true"></el-input> -->
              </el-form-item>
              <el-form-item label="支付方式">
                {{orderData.payType == 1 ? '线上支付' : '线下支付'}}
                <!-- <el-input v-model="orderData.payTime" :disabled="true"></el-input> -->
              </el-form-item>
              <el-form-item label="配送方式">
                {{orderData.deliveryType == 1?'自提':'快递'}}
                <!-- <el-input :value="orderData.deliverType == 1?'自取':'快递'" :disabled="true"></el-input> -->
              </el-form-item>
              <el-form-item label="快递公司">
                {{orderData.expressCom}}
                <!-- <el-input :value="orderData.expressCom" :disabled="true"></el-input> -->
              </el-form-item>
              <el-form-item label="快递单号">
                {{orderData.expressNo}} <el-button v-if="orderData.expressNo" size="mini" @click="checkExpressInfo" type="primary">查看物流</el-button>
                <!-- <el-input v-model="orderData.expressNo" :disabled="true"></el-input> -->
              </el-form-item>
              <el-form-item label="备注信息">
                {{orderData.remark}}
                <!-- <el-input type="textarea" v-model="orderData.remark" :disabled="true"></el-input> -->
              </el-form-item>
            </el-form>
          </div>
          <div class="subTitle"><span></span>订单信息</div>
          <div class="listTh">
            <el-row>
              <el-col :span="14">订单详情</el-col>
              <el-col :span="3">单价</el-col>
              <el-col :span="3">数量</el-col>
              <el-col :span="4">金额</el-col>
            </el-row>
          </div>
          <div class="orderList">
            <ul>
              <li style="margin-bottom: 10px;">
                <div class="itemT">订单时间：{{orderData.createDate ? orderData.createDate.substring(0,19) : ''}} &nbsp;&nbsp; 订单编号：{{orderData.orderCode}}</div>
                <div class="itemC">
                  <el-row class="proInfo" v-for="(item,index) in goodsOrderDetails" :key="index">
                    <el-col :span="14">
                      <div class="imgBox"><router-link :to="'/productDetails/'+item.goodsId"><img :src="item.pic"></router-link></div>
                      <div class="infoBox">
                        <p class="p1">{{item.name}}</p>
                        <p class="p2">{{item.property}}</p>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="itemTd price">￥{{parseFloat(item.memberPrice || 0).toFixed(2)}}</div>
                    </el-col>
                    <el-col :span="3">
                      <div class="itemTd num">x{{item.num}}</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="itemTd pay">￥{{(parseFloat(item.memberPrice) * parseFloat(item.num)).toFixed(2)}}</div>
                    </el-col>
                    <div class="evaluateBox" v-if="orderData.status == 4">
                      <div class="evaluateState">
                        <div class="starBox">
                          <span :class="{'active':item.goodsEvaluation.star>0}" @click="selectStar(item,1)"></span>
                          <span :class="{'active':item.goodsEvaluation.star>1}" @click="selectStar(item,2)"></span>
                          <span :class="{'active':item.goodsEvaluation.star>2}" @click="selectStar(item,3)"></span>
                          <span :class="{'active':item.goodsEvaluation.star>3}" @click="selectStar(item,4)"></span>
                          <span :class="{'active':item.goodsEvaluation.star>4}" @click="selectStar(item,5)"></span>
                        </div>
                        <div class="status">{{item.hasEvaluation == 1 ? '待评价' : '已评价'}}</div>
                      </div>
                      <div class="evaluateInfo">
                        <el-input
                          :disabled="item.hasEvaluation == 2"
                          @input="valueChange"
                          :maxlength="300"
                          type="textarea"
                          placeholder="请输入内容"
                          :rows="3"
                          v-model="item.goodsEvaluation.desc"
                          >
                        </el-input>
                      </div>
                      <div class="evaluateBtn" v-if="item.hasEvaluation == 1 && (index == goodsOrderDetails.length-1)"><span @click="addEvaluate()">提交</span></div>
                    </div>
                  </el-row>
                  <el-row class="priceInfo" style="padding-top: 10px;">
                    <el-col :span="18" class="lT" style="text-align: right;">获得积分：</el-col>
                    <el-col :span="6"  class="rC" style="text-align: right;padding-right: 20px;">{{orderData.credits}}</el-col>
                  </el-row>
                  <el-row class="priceInfo">
                    <el-col :span="18" class="lT" style="text-align: right;">订单总价：</el-col>
                    <el-col :span="6"  class="rC" style="text-align: right;padding-right: 20px;">￥{{parseFloat(orderData.total || 0).toFixed(2)}}</el-col>
                  </el-row>
                  <el-row class="priceInfo">
                    <el-col :span="18" class="lT" style="text-align: right;">实付金额：</el-col>
                    <el-col :span="6"  class="rC" style="text-align: right;padding-right: 20px;">￥{{parseFloat(orderData.pay || 0).toFixed(2)}}</el-col>
                  </el-row>
                  <el-row class="priceInfo" style="text-align: right;padding: 20px 0 10px;" v-if="orderData.status == 1">
                    <span class="opBtn cancel" @click="cancelOrder(orderData.id)">取消订单</span>
                    <span class="opBtn pay" @click="confirmPay">确认支付</span>
                  </el-row>
                  <!-- <el-row class="priceInfo" style="text-align: right;padding: 20px 0 10px;" v-if="orderData.status == 2">
                    <span>订单已支付，等待商家发货</span>
                  </el-row> -->
                  <el-row class="priceInfo" style="text-align: right;padding: 20px 0 10px;" v-if="orderData.status == 3">
                    <span class="opBtn pay" @click="confirmReceived">确认收货</span>
                  </el-row>
                  <!-- <el-row class="priceInfo" style="text-align: right;padding: 20px 0 10px;" v-if="orderData.status == 4">
                    <span>订单已完成; 快递公司：{{orderData.expressCom}}; 订单号：{{orderData.expressNo}}</span>
                  </el-row> -->
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <el-dialog
        title="请微信扫码支付"
        :visible.sync="payBoxVisible"
        width="30%">
        <div>
          <img style="display: block;margin:auto;" :src="payCodeUrl">
        </div>
      </el-dialog> -->
      <div class="zdyPayBox" v-show="payBoxVisible">
        <div class="payContent">
          <p>付款金额为<br><span>{{orderData.pay}}</span>元</p>
          <img style="display: block;margin:auto;" :src="payCodeUrl">
          <span class="close" @click="closePay"></span>
        </div>
      </div>

      <!-- 物流信息 -->
      <el-dialog  :title="'快递公司：'+ orderData.expressCom + '\xa0 \xa0 \xa0 \xa0快递号：' + orderData.expressNo" :visible.sync="tracesVisible" width="45%">
          <div>
              <!-- <div v-for="(item,index) in TracesList" :key="index" class="tracesItem">
                  <p class="p1">{{item.AcceptStation}}</p>
                  <p class="p2">&nbsp;&nbsp;{{item.AcceptTime}}</p>
              </div>
              <div v-if="TracesList.length == 0" style="padding: 100px 0;color:#999999;text-align: center;">
                  暂无物流跟踪信息
              </div> -->
              <p class="wlTitle">物流信息：</p>
                <div style="padding: 0 20px;">
                    <el-timeline>
                        <el-timeline-item
                          v-for="(activity, index) in TracesList"
                          :key="index"
                          :color="index == 0 ? '#5680fa' : ''"
                          size="large"
                          :timestamp="activity.AcceptTime">
                          {{activity.AcceptStation}}
                        </el-timeline-item>
                    </el-timeline>
                </div>
                <div v-if="TracesList.length == 0" style="padding: 100px 0;color:#999999;text-align: center;">
                    暂无物流跟踪信息
                </div>
          </div>
      </el-dialog>

      <!---前往公众号支付-->
      <el-dialog :visible.sync="goGZHVisiable" title="订单支付" append-to-body width="338px">
        <div style="padding: 0 20px;">
          <img src="/static/images/gongzhonghao.jpg" alt="公众号" />
          <p style="display:block; line-height: 30px; font-size:16px; color:#333;">请移步到公众号【会员中心】【我的】【商品订单】支付</p>
        </div>
      </el-dialog>
      
    </div>
  </div>
</template>

<script>
  import LeftSide from './common/leftside'
  import eventVue from '../bus.js'
  import QRCode from 'qrcode'
  export default {
    components: {
      LeftSide
    },
    data(){
      return {
        orderId:'',
        orderData:{},
        evaluateStr:'',
        goodsOrderDetails:[], //商品列表
        cancelAble:false,
        payCodeUrl:'',
        payBoxVisible:false,
        starNum:0,

        tracesVisible:false,
        TracesList:[],
        //前往公众号支付
        goGZHVisiable : false,
      }
    },
    computed: {
      userData() {
        return this.$store.state.userData
      }
    },
    // beforeRouteEnter (to, from, next) {
    //   if(from.name == "activeOrderConfirm"){
    //     next(vm => {
    //       vm.cancelAble = true
    //     })
    //   }else{
    //     next()
    //   }
    // },
    created(){
      this.orderId = this.$route.params.id
      this.getOrderObj()
    },
    mounted(){
      eventVue.$emit("leftSwitch",'3')
    },
    methods:{
      //查看物流详情
      checkExpressInfo(){
          this.$https.get(`/api/express?expressComNo=${this.orderData.expressComNo}&expressNo=${this.orderData.expressNo}`).then(res => {
              if(res.data.Traces){
                  this.TracesList = res.data.Traces.reverse()
              }else{
                  this.TracesList = []
              }
              this.tracesVisible = true
          });
      },
      //确认收货
      confirmReceived(){
        this.$confirm('请确保已经收到商品？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$https.post('/api/goodsOrder/updateGoodsOrderStatus/id/'+this.orderId,{}).then(res => {
            if(res.code == 0){
              this.$message.success("操作成功")
              this.getOrderObj()
              // this.$router.go(-1)
            }else{
              this.$message.warning(res.msg)
            }
          });
        }).catch(() => {});
      },
      //选择评价星星
      selectStar(item,star){
        item.goodsEvaluation.star = star
        this.$forceUpdate()
      },
      //
      valueChange(){
        this.$forceUpdate()
      },
      statusChange(sta){
        this.status = sta
        this.curPage = 1
        this.getOrderList()
      },
      getOrderObj(){
        this.$https.get('/api/goodsOrder/id/'+this.orderId).then((response)=>{
          response.data.createDate = response.data.createDate.substring(0,19)
          response.data.payTime = response.data.payTime?response.data.payTime.substring(0,19):''
          this.orderData = response.data
          response.data.goodsOrderDetails.forEach(item => {
            if (!item.goodsEvaluation) {
              let tempObj={}
              tempObj.star = 0
              tempObj.desc = ''
              item.goodsEvaluation = tempObj
            }
          })
          this.goodsOrderDetails = response.data.goodsOrderDetails
        });
      },
      cancelOrder(id){
        this.$confirm('是否取消该订单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$https.post('/api/goodsOrder/id/'+id,{}).then(res => {
            if(res.code == 0){
              this.$message.success("操作成功")
              this.$router.go(-1)
            }else{
              this.$message.warning(res.msg)
            }
          });
        }).catch(() => {});
      },
      //确认支付生成二维码参数
      confirmPay(){
      if(!this.userData.openidPub){
        this.goGZHVisiable = true
        return;
      }
        this.$https.get(`/api/wechatPay/getNATIVEPay?openid=${this.userData.openidPub}&orderCode=${this.orderData.orderCode}&orderType=1`).then((response)=>{
          QRCode.toDataURL(response.data).then(url => {
            this.payCodeUrl = url
            this.payBoxVisible = true
          }).catch(err => {
            console.warning(err)
          })
        });
      },
      closePay(){
        this.getOrderObj()
        this.payBoxVisible = false
      },

      //添加评价
      addEvaluate(item){
        // if(item.goodsEvaluation.star == 0){
        //   this.$message.warning("请选择评价星级")
        //   return
        // }
        // if(item.goodsEvaluation.desc == ''){
        //   this.$message.warning("请输入评价内容")
        //   return
        // }
        let data = []
        let flag = false
        for (var i = 0; i < this.goodsOrderDetails.length; i++) {
          let row = this.goodsOrderDetails[i]
          if(row.goodsEvaluation.star == 0){
            this.$message.warning("请选择第"+(i+1)+"个商品评价星级")
            flag = true
            break
          }
          if(row.goodsEvaluation.desc == ''){
            this.$message.warning("请输入第"+(i+1)+"个商品评价内容")
            flag = true
            break
          }
          let _data = {
            desc:row.goodsEvaluation.desc,
            goodsId:row.goodsId,
            memberId:this.userData.id,
            nickname:this.userData.nickname,
            orderCode:this.orderData.orderCode,
            orderDetailId:row.id,
            orderId:this.orderData.id,
            star:row.goodsEvaluation.star
          }
          data.push(_data)
        }
        if(flag){
          return
        }
        this.$https.post('/api/goodsEvaluation/addGoodsEvaluation',data).then(res => {
          if(res.code == 0){
            this.$message.success("操作成功")
            this.getOrderObj()
          }else{
            this.$message.warning(res.msg)
          }
        });
      }
    }
  }
</script>

<style scoped>
  /deep/ .el-form-item__label{
    text-align: left;
  }
  /deep/ .el-form-item{
    margin-bottom: 0px;
  }
  .zdyPayBox{
    position: fixed;
    z-index: 9999;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
  }
  .zdyPayBox .payContent{
    width: 684px;
    height: 534px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -267px 0 0 -342px;
    background: url("../assets/images/payPop.png");
  }
  .zdyPayBox .payContent p{
    line-height: 28px;
    position: absolute;
    width: 100%;
    left: 0px;
    top: 150px;
    text-align: center;
    font-size: 16px;
    color: #ffffff;
  }
  .zdyPayBox .payContent p span{
    font-size:18px;
    color: #eea10d;
  }
  .zdyPayBox .payContent img{
    width: 210px;
    height: 192px;
    position: absolute;
    top: 221px;
    left: 242px;
  }
  .zdyPayBox .payContent .close{
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    top: 38px;
    right: 38px;
    cursor: pointer;
  }
  .spanInlineBox{
    display: inline-block;
    width: 130px;
  }
  .userInfoBox{
    width: 760px;
    padding-top: 24px;
  }
  .editBtn{
    position: absolute;
    color: #5680f9;
    right: 20px;
    top: 14px;
    font-size: 16px;
    cursor: pointer;
  }
  .subTitle{
    padding: 10px 0 0 15px;
    height: 52px;
    line-height: 52px;
    font-size: 18px;
    color: #333333;
  }
  .subTitle span{
    display: inline-block;
    width: 13px;
    height: 13px;
    background: #5680F9;
    border-radius: 50%;
    margin-right: 15px;
  }
  .orderInfo{width: 818px;padding-left: 15px;margin-bottom: 50px;}
  .orderInfo .inforTh{
    padding: 0 25px;
    height: 32px;
    line-height: 32px;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    font-size: 12px;
    color: #666666;
  }
  .orderInfo .inforTd{
    padding: 12px;
    background: #FBFBFB;
    border: 1px solid #E5E5E5;
    border-top: 0px;
    position: relative;
    overflow: hidden;
  }
  .inforTdLeft{
    width: 221px;
    float: left;
  }
  .inforTdLeft .imgBox{
    width: 219px;
    height: 169px;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    margin-bottom: 10px;
  }
  .inforTdLeft .imgBox img{
    width: 100%;
    height: 100%;
  }
  .inforTdLeft p{
    line-height: 30px;
    font-size: 14px;
    color: #666666;
  }
  .inforTdRight{
    padding-left: 245px;
    padding-right: 30px;
  }
  .inforTdRight .title{
    height: 40px;
    overflow: hidden;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
  }
  .inforTdRight .proper{
    font-size: 12px;
    color: #919191;
    margin-top: 15px;
  }
  .inforTdRight .time{
    width: 293px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    color: #5680F9;
    border: 1px solid #5680F9;
    margin-top: 18px;
  }
  .inforTdRight .num{
    line-height: 24px;
    margin-top: 15px;
  }
  .inforTdRight .num .span1{
    font-size: 14px;
    color: #666666;
    display: inline-block;
  }
  .inforTdRight .num .span2{
    color: #919191;
    font-size: 14px;
    width: 80px;
    display: inline-block;
    margin-left: 46px;
  }
  .inforTdRight .num .span3{
    color: #666666;
    font-size: 14px;
    display: inline-block;
  }
  .inforTdRight .price{
    line-height: 30px;
    font-size: 14px;
    color: #666666;
    text-align: right;
  }
  .inforTdRight .price span{
    color: #E50001;
  }
  .inforTdRight .btn{
    text-align: right;
  }
  .inforTdRight .btn span{
    display: inline-block;
    width: 85px;
    height: 27px;
    line-height: 26px;
    text-align: center;
    background: #FFCD30;
    border-radius: 4px;
    color: #FFFEFE;
    font-size: 16px;
    /*position: absolute;
    bottom: 12px;*/
    cursor: pointer;
    margin-top: 20px;
  }
  .evaluateBox{
    clear: both;
    padding: 10px;
    border-bottom: 1px solid #E5E5E5;
    margin: 10px 0;
  }
  .evaluateBox .evaluateState{
    overflow: hidden;
  }
  .evaluateBox .evaluateState .starBox{
    float: left;
  }
  .evaluateBox .evaluateState .starBox span{
    display: inline-block;
    width: 26px;
    height: 25px;
    background: url("../assets/images/star1.png");
    cursor: pointer;
  }
  .evaluateBox .evaluateState .starBox span.active{
    background: url("../assets/images/start2.png");
  }
  .evaluateBox .evaluateState .status{
    float: right;
    width: 85px;
    height: 27px;
    line-height: 26px;
    text-align: center;
    background: #FFCD30;
    border-radius: 4px;
    color: #FFFEFE;
    font-size: 16px;
    cursor: pointer;
  }
  .evaluateBox .evaluateInfo{
    margin-top: 5px;
  }
  .evaluateBox .evaluateBtn{
    margin-top: 6px;
    text-align: right;
  }
  .evaluateBox .evaluateBtn span{
    display: inline-block;
    width: 60px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #5680F9;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    color: #FFFFFF;
  }
  .listTh{
    width:816px;
    text-align: center;
    height:36px;
    line-height: 36px;
    font-size: 14px;
    color: #363636;
    background: #F4F7FF;
    border:1px solid rgba(86,128,249,1);
    border-top: 3px solid rgba(86,128,249,1);
    margin: 0px 0 0 16px;
  }
  .orderList{
    width: 818px;
    padding: 0px 0 0 16px;
  }
  .orderList .itemT{
    height: 32px;
    line-height: 32px;
    padding-left: 24px;
    background: #FFFFFF;
    font-size: 12px;
    color: #666666;
    border: 1px solid #E5E5E5;
  }
  .orderList .itemC{
    padding: 12px 0px;
    background: #FBFBFB;
    border: 1px solid #E5E5E5;
    border-top: 0px;
    position: relative;
  }
  .orderList .itemC .opBtn{
    display: inline-block;
    width: 85px;
    height: 27px;
    line-height: 26px;
    text-align: center;
    background: #FFCD30;
    border-radius: 4px;
    color: #FFFEFE;
    font-size: 16px;
    /*position: absolute;
    bottom: 12px;*/
    cursor: pointer;
  }
  .orderList .itemC .opBtn.cancel{right: 16px;}
  .orderList .itemC .opBtn.pay{right: 130px;}
  .orderList .proInfo+.proInfo{
    margin-top: 9px;
  }
  .orderList .imgBox{
    width: 118px;
    height: 118px;
    margin-left: 12px;
    float: left;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
  }
  .orderList .imgBox img{
    width: 100%;
    height: 100%;
  }
  .orderList .infoBox{
    padding: 8px 0 0 142px;
  }
  .orderList .infoBox .p1{
    height: 32px;
    overflow: hidden;
    font-size: 12px;
    color: #666666;
    line-height: 16px;
  }
  .orderList .infoBox .p2{
    margin-top: 20px;
    font-size: 12px;
    color: #919191;
  }
  .orderList .itemTd{
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 14px;
  }
  .orderList .price{
    color: #919191;
  }
  .orderList .num{
    color: #666666;
  }
  .orderList .pay{
    color: #E50001;
  }
  .orderList .operation{
    height: 27px;
    line-height: 27px;
  }
  .orderList .operation span{
    text-decoration: underline;
    cursor: pointer;
    color: #5680F9;
  }
  .priceInfo{
    margin: 0 13px;
    line-height: 30px;
    color: #666666;
    font-size: 14px;
  }
  .btn-box{
    padding: 23px 13px 10px;
    text-align: right;
  }
  /*.userInfoBox{
    width: 454px;
    padding-top: 24px;
  }*/

  .tracesItem{
        border-bottom:1px dashed #999;
        padding: 5px 0px;
    }
    .tracesItem .p1{
        line-height: 21px;
        font-size: 14px;
        color: #333333;
    }
    .tracesItem .p2{
        font-size: 12px;
        color: #999999;
    }

    .wlTitle{
        font-size: 16px;
        color: #333333;
        margin-top: -20px;
        padding: 0 10px;
        margin-bottom: 20px;
    }
    /deep/ .el-dialog__title{
        font-size: 18px;
        color: #666666;
    }
    /deep/ .el-dialog__header{
        border-bottom: 1px solid #e1e1e1;
    }
    /deep/ .el-timeline-item__content{
        color: #999999;
        font-size: 14px;
    }
    /deep/ .el-timeline-item__timestamp{
        color: #999999;
        font-size: 14px;
    }
    /deep/ .el-timeline li:first-child .el-timeline-item__content{
        color: #5680fa
    }
    /deep/ .el-timeline li:first-child .el-timeline-item__timestamp{
        color: #5680fa
    }
    /deep/ .el-timeline li:first-child .el-timeline-item__node::after{
        content: " ";
        position: absolute;
        top: -2px;
        left: -2px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border:1px solid #5680fa;
    }

</style>



// WEBPACK FOOTER //
// src/components/proOrderDetail.vue